module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "payment-success"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('div', {
    staticClass: "payment-success__wrapper"
  }, [_c('div', {
    staticClass: "py-5 mb-5"
  }, [_c('div', {
    staticClass: "w-100 d-flex justify-center"
  }, [_c('router-link', {
    staticClass: "mw-145",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/nav_logo_primary.png'),
      "width": "145px"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-100 d-flex justify-center"
  }, [_c('div', {
    staticClass: "payment-success__content"
  }, [_c('div', {
    staticClass: "payment-success__title d-flex align-center"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/images/circle_check.svg"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("Payment successful")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex payment-success__description"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('div', [_vm._v("Hi, John!")]), _vm._v(" "), _c('div', [_vm._v("You’ve upgraded.")]), _vm._v(" "), (_vm.accountCategory === 'creator') ? _c('div', {
    staticClass: "note"
  }, [_vm._v("\n                Your creator account is pending verification. Please allow up\n                to 72 hours. Your listener subscription is active, download\n                the app & go!\n              ")]) : _c('div', {
    staticClass: "note"
  }, [_vm._v("\n                Your listener subscription is active, download the app & go!\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "minw-315"
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/images/people.svg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center gap-14 payment-success__icon"
  }, [_c('div', {
    staticClass: "mw-145 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.IOS)
      }
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/images/app-store.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mw-145 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openQrCode(_vm.qrCodeTypeList.ANDROID)
      }
    }
  }, [_c('img', {
    staticClass: "w-100",
    attrs: {
      "src": "/static/images/play-store.svg"
    }
  })])])])])])]), _vm._v(" "), _c('QrCode', {
    ref: "qrCode"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb3d1f5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentCard/paymentSuccess.vue
// module id = 1641
// module chunks = 180